$(document).ready(function () {
  window.quizAnswers = [];

  function sendToGoogleSheet() {
    const payload = {
      answers: window.quizAnswers,
    };

    fetch(
      "https://script.google.com/macros/s/AKfycby2gPmBgr8DAr6UFC3nFcMawJRsDPb9evNNcls215mk8JuSAczwQx2zVSOY1N8g6YEKVA/exec",
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    )
      .then(() => {
        console.log(
          "%c✅ Quiz data sent to Google Sheet",
          "color: green; font-weight: bold;"
        );
      })
      .catch((err) => {
        console.error("❌ Google Sheets error:", err);
      });
  }

  function saveQuizAnswer(questionIndex, questionText, answerValue) {
    window.quizAnswers = window.quizAnswers.filter(
      (a) => a.index != questionIndex
    );

    window.quizAnswers.push({
      index: questionIndex,
      question: questionText,
      answer: answerValue,
    });

    // Save to cookie
    setCookie("quizAnswers", JSON.stringify(window.quizAnswers), 31);

    console.log("✅ Saved:", questionText, " → ", answerValue);
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  sendGAEvent("Quiz_event_started", "Quiz button");

  $(".col_quiz_grid_block").click(function () {
    var $inner = $(this).closest(".col_quiz_inner");
    var currentIndex = $inner.attr("data-index");
    var questionText = $inner.find(".col_quiz_title").text().trim();
    var answerValue = $(this).find(".col_quiz_answer").text().trim();

    saveQuizAnswer(currentIndex, questionText, answerValue);

    // Existing poop logic
    var isPoop = $inner.attr("data-poop");
    if (isPoop === "true") {
      $(".col_quiz_data").attr("data-poop", answerValue);
    }

    showNextQuestion(currentIndex);
  });

  $(".col_quiz_btn").click(function () {
    var mode = $(this).attr("data");
    if (mode == "email_step") {
      var getEmail = String($(".col_quiz_email_collection__js").val());

      if (getEmail.indexOf("@") != -1) {
        console.log(getEmail);
        sendKlaviyoEmail();
      }
    } else {
    if (!$(this).hasClass("disabled")) {

      var $current = $(this).closest(".col_quiz_inner");
      var currentIndex = $current.attr("data-index");
      var questionText = $current.find(".col_quiz_title").text().trim();

      // ⭐ SAVE NAME ANSWER HERE
      var nameInput = $current.find(".col_quiz_age_field.name");
      if (nameInput.length) {
        var nameValue = nameInput.val().trim();
        saveQuizAnswer(currentIndex, questionText, nameValue);
      }

      showNextQuestion(currentIndex);
    }
  }

  });

  $(".multiSelect").click(function () {
    var currentAnswer = $(this).attr("data");
    if (currentAnswer == "none" || currentAnswer == "prefer-not-to-say") {
      $(this)
        .closest(".col_quiz_grid")
        .find(".multiSelect")
        .removeClass("active");
    } else {
      $('.multiSelect[data="none"]').removeClass("active");
      $('.multiSelect[data="prefer-not-to-say"]').removeClass("active");
    }
    $(this).toggleClass("active");
    var allActives = 0;
    $(this)
      .closest(".col_quiz_inner")
      .find(".multiSelect.active")
      .each(function () {
        allActives++;
      });

    if (allActives > 0) {
      $(this)
        .closest(".col_quiz_inner")
        .find(".col_quiz_btn")
        .removeClass("disabled");
    } else {
      $(this)
        .closest(".col_quiz_inner")
        .find(".col_quiz_btn")
        .addClass("disabled");
    }

    console.log(allActives);

    var $inner = $(this).closest(".col_quiz_inner");
    var questionIndex = $inner.attr("data-index");
    var questionText = $inner.find(".col_quiz_title").text().trim();

    var answers = [];
    $inner.find(".multiSelect.active .col_quiz_answer").each(function () {
      answers.push($(this).text().trim());
    });

    saveQuizAnswer(questionIndex, questionText, answers.join(", "));
  });

  $(".col_quiz_go_back").click(function () {
    var currentIndex = $(".col_quiz_inner.visible").attr("data-index");
    console.log(currentIndex, " current index");
    showPrevQuestion(currentIndex);
  });

  // Function to validate age input
  function validateAgeInput($input) {
    const value = parseInt($input.val()) || 0;
    const $button = $input.closest(".col_quiz_inner").find(".col_quiz_btn");

    if (value >= 18 && value <= 100) {
      $button.removeClass("disabled");
    } else {
      $button.addClass("disabled");
    }
  }

  // Age input validation on keyup
  $(".col_quiz_age_field.age").on("keyup", function () {
    validateAgeInput($(this));
  });

  // Function to check if button should be enabled
  function validateHeightInputs($heightInput) {
    const unit = $heightInput.find(".col_quiz_unit_btn.active").data("unit");
    const $button = $heightInput
      .closest(".col_quiz_inner")
      .find(".col_quiz_btn");

    if (unit === "imperial") {
      // Check if metric input is empty
      const metricValue = $heightInput.find(".metric-wrapper input").val();

      // Get imperial values
      const ftValue = $heightInput.find(".imperial-ft").val();
      const inValue = $heightInput.find(".imperial-in").val();

      // Validate imperial mode
      if (metricValue) {
        // If metric has value while in imperial mode, disable button
        $button.addClass("disabled");
      } else if (ftValue || inValue) {
        // If either ft or in has a value, check if they're valid
        const ft = parseInt(ftValue) || 0;
        const inch = parseInt(inValue) || 0;

        if (
          (ftValue && (ft < 4 || ft > 7)) ||
          (inValue && (inch < 0 || inch > 11))
        ) {
          $button.addClass("disabled");
        } else {
          $button.removeClass("disabled");
        }
      } else {
        // No values entered
        $button.addClass("disabled");
      }
    } else {
      // Get metric value
      const metricValue = $(".col_quiz_age_field.metric").val();
      const cm = parseInt(metricValue) || 0;
      console.log(metricValue, cm, "TESTING ");
      if (metricValue && cm >= 10 && cm <= 250) {
        $button.removeClass("disabled");
      } else {
        $button.addClass("disabled");
      }
    }
  }

  // Unit switch handler
  $(".col_quiz_unit_btn").click(function () {
    const unit = $(this).data("unit");
    const $heightInput = $(this).closest(".col_quiz_Height_input");
    const $metricWrapper = $heightInput.find(".metric-wrapper");
    const $imperialWrapper = $heightInput.find(".imperial-wrapper");
    const $button = $(this).closest(".col_quiz_inner").find(".col_quiz_btn");

    // Update active state
    $(".col_quiz_unit_btn").removeClass("active");
    $('.col_quiz_unit_btn[data-unit="' + unit + '"]').addClass("active");

    // Toggle input wrappers
    if (unit === "imperial") {
      $metricWrapper.hide();
      $imperialWrapper.show();
      $('.col_quiz_age_suffix[data="lb"]').removeClass("hidden");
      $('.col_quiz_age_suffix[data="kg"]').addClass("hidden");
    } else {
      $imperialWrapper.hide();
      $metricWrapper.show();
      $('.col_quiz_age_suffix[data="lb"]').addClass("hidden");
      $('.col_quiz_age_suffix[data="kg"]').removeClass("hidden");
    }

    // Clear all inputs when switching units
    $(this).closest(".col_quiz_inner").find("input").val("");
    // $(".col_quiz_age_field:not(.age)").val("");
    $button.addClass("disabled");
  });

  // Height input validation on keyup
  $(".col_quiz_Height_input input").on("keyup", function () {
    const $heightInput = $(this).closest(".col_quiz_Height_input");
    validateHeightInputs($heightInput);
  });

  // Function to validate weight inputs
  function validateWeightInputs($weightInput) {
    const $button = $weightInput
      .closest(".col_quiz_inner")
      .find(".col_quiz_btn");
    const weight = $weightInput.find(".weight").val();
    const desiredWeight = $weightInput.find(".desired_weight").val();

    if (weight && desiredWeight) {
      $button.removeClass("disabled");
    } else {
      $button.addClass("disabled");
    }
  }

  // Weight input validation on keyup
  $(
    ".col_quiz_Age_input input.weight, .col_quiz_Age_input input.desired_weight"
  ).on("keyup", function () {
    validateWeightInputs($(this).closest(".col_quiz_Age_input"));
  });

  function showNextQuestion(currentIndex) {
    var currentIndex = parseFloat(currentIndex);
    var nextIndex = parseFloat(currentIndex) + 1;
    // console.log(nextIndex);

    var totalQuestions = parseFloat($(".col_quiz_nav_count").attr("data"));
    var nextUrl = $(".col_quiz_outer").attr("data-url");
    if (totalQuestions == currentIndex) {
      // sendToGoogleSheet();
      window.location.href = nextUrl;
      console.log("✅ FINAL ANSWER LIST", window.quizAnswers);
      console.log("✅ Cookie:", JSON.parse(getCookie("quizAnswers") || "[]"));
    } else {
      $(".col_quiz_inner").removeClass("visible");
      $('.col_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");

      var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
      percentage = 100 - percentage;

      $(".col_quiz_progress_inner").css("width", percentage + "%");
      $(".col_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    var selectedAge = $(".col_quiz_age_field.age").val();
    var selectedWeight = $(".col_quiz_age_field.weight").val();
    var selectedDesiredWeight = $(".col_quiz_age_field.desired_weight").val();
    var system = $(".col_quiz_unit_btn.active").attr("data-unit");
    var metricHeight = $(".col_quiz_age_field.metric").val();
    var imperialHeightFt = $(".col_quiz_age_field.imperial-ft").val();
    var imperialHeightIn = $(".col_quiz_age_field.imperial-in").val();
    var poop = $(".col_quiz_data").attr("data-poop");
    var gender = "";
    var locationCurrent = String(window.location.href);
    if (locationCurrent.indexOf("gender=female") != -1) {
      gender = "female";
      setCookie("gender", gender, 31);
    } else if (locationCurrent.indexOf("gender=male") != -1) {
      gender = "male";
      setCookie("gender", gender, 31);
    }

    $(".col_quiz_data").attr("data-age", selectedAge);
    $(".col_quiz_data").attr("data-weight", selectedWeight);
    $(".col_quiz_data").attr("data-desired-weight", selectedDesiredWeight);
    $(".col_quiz_data").attr("data-system", system);
    $(".col_quiz_data").attr("data-height-metric", metricHeight);
    $(".col_quiz_data").attr("data-height-ft-imperial", imperialHeightFt);
    $(".col_quiz_data").attr("data-height-in-imperial", imperialHeightIn);

    var $current = $('.col_quiz_inner[data-index="' + currentIndex + '"]');
    var questionText = $current.find(".col_quiz_title").text().trim();

    if ($current.find(".col_quiz_age_field.age").length) {
      saveQuizAnswer(currentIndex, questionText, selectedAge);
    }
    if ($current.find(".col_quiz_Height_input").length) {
      if (system === "metric") {
        saveQuizAnswer(currentIndex, questionText, metricHeight + " cm");
      } else {
        saveQuizAnswer(
          currentIndex,
          questionText,
          imperialHeightFt + "ft " + imperialHeightIn + "in"
        );
      }
    }
    if ($current.find(".col_quiz_age_field.weight").length) {
      if (system === "metric") {
        saveQuizAnswer(
          currentIndex,
          questionText,
          selectedWeight + " kg → Goal: " + selectedDesiredWeight + " kg"
        );
      } else {
        saveQuizAnswer(
          currentIndex,
          questionText,
          selectedWeight + " lb → Goal: " + selectedDesiredWeight + " lb"
        );
      }
    }

    sendGAEvent("Quiz_event_passed_" + currentIndex + "", "Quiz button");
  }

  function sendGAEvent(eventName, eventLabel) {
    gtag("event", eventName, {
        event_category: "User Actions",
        event_label: eventLabel,
        value: 1,
        event_timestamp: Date.now(),
    });

    console.log(`${eventName} - Sent`);
  }

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; path=/;" + expires;
  }

  function showPrevQuestion(currentIndex) {
    if (currentIndex > 1) {
      var nextIndex = parseFloat(currentIndex) - 1;
      console.log(nextIndex);
      $(".col_quiz_inner").removeClass("visible");
      $('.col_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");

      var totalQuestions = 15;
      var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
      percentage = 100 - percentage;

      $(".col_quiz_progress_inner").css("width", percentage + "%");
      $(".col_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
    } else {
      window.location.href = "/pages/quiz-start";
    }
  }

  function buildKlaviyoQuizPayload(email) {
    let payload = {
      g: "ScPAeZ",
      email: email,
      $source: "Account Creation",
    };

    window.quizAnswers.forEach((item) => {
      const key =
        "quiz_" +
        item.question
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "_") // replace symbols
          .replace(/^_+|_+$/g, ""); // trim underscores

      payload[key] = item.answer; // store answer
    });


    payload["$fields"] = Object.keys(payload).join(",");

    return payload;
  }

  // function sendKlaviyoEmail() {
  //   var email = $(".col_quiz_email_collection__js").val();
  //   var payload = buildKlaviyoQuizPayload(email);

  //   var settings = {
  //     async: true,
  //     crossDomain: true,
  //     url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
  //     method: "POST",
  //     headers: {
  //       "content-type": "application/x-www-form-urlencoded",
  //       "cache-control": "no-cache",
  //     },
  //     data: payload,
  //   };

  //   $.ajax(settings)
  //     .done(function (response) {
  //       console.log("Klaviyo Response:", response);
  //       $(".col_quiz_email_btn_text").html("SUCCESSS!");
  //       sendGAEvent("Quiz_event_passed_email_step", "Quiz button");
  //       var nextUrl = $(".col_quiz_email--data").attr("data-url");
  //       window.location.href = nextUrl;
  //     })
  //     .fail(function (xhr, textStatus, errorThrown) {
  //       console.error(
  //         "Klaviyo Error:",
  //         xhr.responseText || textStatus || errorThrown
  //       );
  //     });
  // }

  function sendKlaviyoEmail() {
    var email = $(".col_quiz_email_collection__js").val();

    var payload = {
      g: "ScPAeZ",
      email: email,
      $source: "Account Creation",
      "Accepts Marketing": "true",
    };

    window.quizAnswers.forEach((item) => {
      const key =
        "quiz_" +
        item.question
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "_")
          .replace(/^_+|_+$/g, "");

      payload[key] = item.answer;
    });

    payload["$fields"] = Object.keys(payload).join(",");

    $.ajax({
      async: true,
      crossDomain: true,
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
      },
      data: $.param(payload), 
    })
      .done(function (response) {
        console.log(" Klaviyo Response:", response);
        $(".col_quiz_email_btn_text").html("SUCCESS!");
        sendGAEvent("Quiz_event_passed_email_step", "Quiz button");
        if (window.savePendingLead) window.savePendingLead("quiz", email);

        var nextUrl = "/pages/quiz-analysis";
        window.location.href = nextUrl;
      })
      .fail(function (xhr, textStatus, errorThrown) {
        console.error(
          " Klaviyo Error:",
          xhr.responseText || textStatus || errorThrown
        );
      });
  }



  $(".col_quiz_email_accept").click(function () {
    $(this).toggleClass("active");
  });

  $(document).on("keyup", ".col_quiz_age_field.name", function () {
    var parent = $(this).closest(".col_quiz_inner");
    var btn = parent.find(".col_quiz_btn");
    var value = $(this).val().trim();

    if (value.length > 0) {
      btn.removeClass("disabled");
    } else {
      btn.addClass("disabled");
    }
  });

  $(document).on("click", "#TSProductSubmitQuiz", function (evt) {
    evt.preventDefault();

    $(this).find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var items = [];

    $(this)
      .closest(".qz_offer-card")
      .find(".qz_offer-card-include-line")
      .each(function () {
        var currentId = $(this).attr("data-id");
        var currentQty = $(this).attr("data-qty");
        items.push({ id: currentId, quantity: currentQty });
      });

    console.log(items);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items, sections: "cell_cart_drawer" }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add to cart");
        return res.json();
      })
      .then((data) => {
        window.refreshCartDrawer(false, data.sections);
        window.openCartDrawer(true);
      })
      .catch((err) => console.error("Error:", err));
  });
});
